export const PaymentWrapper = {
  padding: '11px 10px 3px 0px',
  width: '100%',

  '@media (max-width: 1200px)': {
    padding: '16px',
  },
};

export const PaymentContent = {
  display: 'flex',
  justifyContent: 'space-between',
  gap: '20px',

  '@media (max-width: 900px)': {
    flexDirection: 'column',
  },
};

export const TopCard = {
  padding: '23px 40px',
  borderRadius: '20px',
  marginBottom: '22px',
  boxShadow: '0px 0px 20px 0px #0000000d',

  '@media (max-width: 900px)': {
    padding: '17px 16px',
  },
};

export const PaymentSideBar = {
  padding: '20px',
  boxShadow: '0px 0px 20px 0px #0000000d',
  borderRadius: '20px',
  maxWidth: '383px',
  width: '100%',

  '@media (max-width: 900px)': {
    maxWidth: '100%',
    maxHeight: '67px',
    transition: 'max-height 0.15s ease-out',
    overflow: 'hidden',

    button: {
      width: '100%',
      justifyContent: 'space-between',
    },

    '&.opened-benefits': {
      maxHeight: '700px',
      transition: 'max-height 0.25s ease-in',
    },
  },

  '.sidebar-image': {
    marginLeft: '11px',

    '@media (max-width: 900px)': {
      display: 'block',
      margin: '0 auto',
      maxWidth: '100%',
      height: 'auto',
    },
  },
};

export const PaymentSideBarTextItem = {
  display: 'flex',
  gap: '7px',
  paddingLeft: '3px',
  marginBottom: '6px',
  paddingTop: '4px',

  '.sidebar-text': {
    fontWeight: '400',
    fontSize: '15px',
    lineHeight: '23px',
    letterSpacing: '0.4px',
    color: 'var(--grey400)',
  },
};

export const RightBlock = {
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  width: '100%',
  height: '100%',
};

export const FormControlSelect = {
  maxWidth: '140px',
  width: '100%',
  marginLeft: 'auto',
  marginBottom: '15px',

  '.MuiInputBase-formControl': {
    border: '1px solid var(--grey200)',
    borderRadius: '100px',
    background: 'var(--white)',
  },

  '.MuiOutlinedInput-notchedOutline': {
    border: '0',
  },

  '.MuiInputBase-input': {
    padding: '7px 16px',

    '.select-circle': {
      display: 'none',
    },
  },
};

export const notificationContainer = {
  padding: '0',
  marginBottom: '20px',
  gap: '4px',

  '.MuiPaper-elevation': {
    padding: '11px 16px',
    borderRadius: '8px',

    '@media (max-width: 768px)': {
      flexWrap: 'wrap',
      justifyContent: 'center',
      textAlign: 'center',
      padding: '4px',
    },
  },

  '.MuiAlert-action': {
    alignItems: 'center',
    padding: '0',
    marginRight: '0',

    '@media (max-width: 768px)': {
      marginRight: 'auto',
    },
  },
};

export const PaperSelect = {
  border: '1px solid var(--grey200)',
  background: 'var(--white)',
  borderRadius: '20px',
  boxShadow: 'none',

  '.MuiMenu-list': {
    padding: '12px 20px',

    '.MuiMenuItem-root, .MuiMenuItem-root:hover, .Mui-selected': {
      padding: '4px 0',
      gap: '8px',
      background: 'none',
    },

    '.select-circle': {
      display: 'flex',
      justifyContent: 'flex-end',
      alignItems: 'center',
      width: '20px',
      height: '20px',
      borderRadius: '50%',
      border: '1px solid var(--grey200)',
      background: 'var(--white)',

      svg: {
        fill: 'var(--white)',
        width: '16px',
      },
    },

    '.Mui-selected': {
      '.select-circle': {
        background: 'var(--primary)',
      },
    },
  },
};

export const SelectedPeriodWrapper = {
  display: 'flex',
  flexDirection: 'column',
  gap: '16px',
};

export const SelectedPeriod = {
  position: 'relative',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  padding: '22px',
  borderRadius: '20px',
  background: 'var(--white)',
  boxShadow: '0px 0px 20px 0px #0000000d',
  border: '2px solid transparent',
  transition: '0.3s',

  '&.selected-period': {
    border: '2px solid var(--primary)',
  },
};

export const PeriodWrapper = {
  display: 'grid',
  gridTemplateColumns: 'auto auto',
  textAlign: 'center',
  gap: '4px 32px',

  '@media (max-width: 900px)': {
    gap: '0 16px',
  },
};

export const PeriodCircle = {
  gridRow: 'span 2',
  alignSelf: 'center',
  width: '23px',
  height: '23px',
  borderRadius: '50%',
  boxShadow: '0 0 0 1px var(--primary)',
  transition: '0.3s',

  '&.selected-period': {
    background: 'var(--primary)',
    border: '4px solid var(--white)',
  },
};

export const PeriodTimeText = {
  width: 'fit-content',
  fontWeight: '500',
  fontSize: '16px',
  lineHeight: '23px',
  letterSpacing: '-0.8px',
  textTransform: 'uppercase',
  padding: '8px 12px',
  background: 'var(--lightGray)',
  color: 'var(--grey400)',
  textAlign: 'center',

  '&.yearly-period': {
    background: 'var(--green100)',
    color: 'var(--greenMain)',
  },
};

export const PeriodBillText = {
  fontWeight: '400',
  fontSize: '15px',
  lineHeight: '21px',
  letterSpacing: '0.3px',

  '@media (max-width: 900px)': {
    display: 'none',
  },

  '&.yearly-period': {
    color: 'var(--primary)',
  },
};

export const AmountWrapper = {
  display: 'flex',
  flexDirection: 'column',
  textAlign: 'right',

  '.save-amount-text': {
    fontWeight: '600',
    fontSize: '18px',
    lineHeight: '100%',
    letterSpacing: '0%',
    textDecoration: 'line-through',
    color: 'var(--grey400)',
    verticalAlign: 'top',

    '@media (max-width: 900px)': {
      display: 'none',
    },
  },

  '.current-price': {
    fontWeight: '600',
    fontSize: '22px',
    lineHeight: '23px',
    letterSpacing: '0.3px',
    margin: '0 9px 0 16px',
  },

  '.month-text': {
    fontWeight: '400',
    fontSize: '13px',
    letterSpacing: '0.5px',
    lineHeight: '100%',
    color: 'var(--grey400)',
  },
};

export const SaveAnuallyText = {
  fontSize: '15px',
  lineHeight: '18px',
  letterSpacing: '0.1px',
  marginTop: '9px',
  color: 'var(--orange2)',
};

export const ActiveSubscription = {
  position: 'absolute',
  left: '-14px',
  top: '-12px',
  padding: '4px 12px',
  borderRadius: '13px',
  background: 'var(--greenMain)',
  color: 'var(--white)',
};

export const PaymentbestChoiceLabel = {
  position: 'absolute',
  top: '-2px',
  left: '50%',
  transform: 'translateX(-50%)',
  fontSize: '14px',
  textAlign: 'center',
  color: 'var(--white)',
  padding: '4px 10px',
  borderRadius: '0 0 4px 4px',
  background: 'var(--black)',
};

export const PaymentbestChoiceButtons = {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-end',
  margin: '16px 0 0',
  gap: '6px',
  paddingTop: '30px',

  '& .MuiButton-contained.MuiButtonBase-root.confirm-button': {
    padding: '10px 22px',
  },

  '@media (max-width: 900px)': {
    alignItems: 'center',
  },
};
